export default "__VITE_ASSET__2j5k30M3__"